import React from 'react'

function OffersCountCell(r) {
  if(!r) return 
  return (
    <div>{r?.offersList?.length}</div>
  )
}

export default OffersCountCell